/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: NotificheCrud.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/NotificheCrud.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 22/07/26, 13:38;
 *  Updated at: 22/07/26, 13:38;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../app/shared/models/campo-aggiuntivo";
import {DateToString} from "../Utility/DateUtility";

function NotificheCrud() {
  var OBJ: OggettoConfig = {
    Id: "NotificheCrud",
    MenuItems: [
      {
        path: "/shared/dynamiclist/NotificheCrud",
        title: "Notifiche",
        icon: "fas fa-bilding",
        class: "",
        capacita: ['menu-notifiche'],
      },
    ],
    PrintHeaders:[
      { nome: 'Titolo:', oggetti: ['nome'], modificabile: false, inputType: 'text', class: 'col-lg-12' },
      { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
      { nome: 'Publica:', oggetti: ['publicata'], modificabile: false, inputType: 'checkbox', class: 'col-lg-3' },
      CampoAggiuntivo.Html("Clienti Notificati:", (x)=>`${x.clientiObject.length}`),
    ],

      ListDefaultFilter:{inizio: DateToString(new Date()), fine: DateToString(new Date()), periodo:true},
      RestRoute: '/task/notifiche',
      Label: 'Notifica',
    ListResponseHasData: true,
    GetResponseHasData: true,
      Headers:[
        { nome: 'Titolo:', oggetti: ['nome'], modificabile: false, inputType: 'text', class: 'col-lg-12' },
        { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
        { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
        { nome: 'Publica:', oggetti: ['publicata'], modificabile: false, inputType: 'checkbox', class: 'col-lg-3' },
        CampoAggiuntivo.Html("Clienti Notificati:", (x)=>`${x.clientiObject.length}`),

      ],
      campi: [
        { nome: 'Titolo:', oggetti: ['nome'], modificabile: false, inputType: 'text', class: 'col-lg-12' },
        { nome: 'Body:', oggetti: ['note'], modificabile: false, class: 'col-lg-12' },
        { nome: 'Data:', oggetti: ['data_inizio_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
        { nome: 'Data Fine:', oggetti: ['data_fine_prevista'], modificabile: false, inputType: 'date', class: 'col-lg-3' },
        { nome: 'Publica:', oggetti: ['publicata'], modificabile: false, inputType: 'checkbox', class: 'col-lg-3' },
        {
          type: 'image',
          oggetti: ['id_immagine'],
          imageToServer: 'immagine',
          filename: 'file',
          titleClass: 'control-label col-form-label',
          class: 'col-md-12',
          visibleifProhibited: true,
          modificabile: false
        },
        CampoAggiuntivo.Html("Clienti Notificati:", (x)=>`Clienti Notificati: ${x.clientiObject.length}`),
        //CampoAggiuntivo.SingleDropdown("Clienti", "addclienti", '/anagrafica/clienti/list', 'nominativo', { OnChange: "AddCli", parameter:[{nome: 'page', value:0}, {nome:'size', value: 10}, {nome:"ruolo", value: 'C'}], responseHasData:true }),
       // { nome: 'Clienti', collapsable: true, collapsed: true, oggetti: ['clientiObject'], type: "table", header: [{ nome: "Cliente", oggetti: ['nominativo'] }], modificabile: true, class: 'col-lg-12', azioni: [{ ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip: 'Elimina', color: 'red' }] },

      ]


  }
  return OBJ;
}


export var NotificheCrudEnv = () => {
  var env: any = {
    Modules: {
      "NotificheCrud": true
    },
    Cruds: [NotificheCrud()],
    Menu: [...NotificheCrud().MenuItems]
  }
  return env;

}
